import { useEffect, useState } from 'react';

export const usePageDesignHeaderMaxWidths = ({ header }) => {
  const [maxWidths, setMaxWidths] = useState([]);

  if (!header) return [];

  useEffect(() => {
    const imageSources = header?.image?.sources || [];
    const videoSources = header?.video?.sources || [];

    const getMaxWidths = () => {
      const imageMaxWidths = imageSources
        ? imageSources
            .sort((a, b) => {
              if ((a.minDisplayWidth || b.minDisplayWidth) && a?.minDisplayWidth !== b?.minDisplayWidth) {
                return b?.minDisplayWidth - a?.minDisplayWidth;
              }

              // make sure that landscape is before portrait
              if (
                (a?.mediaOrientation || b?.mediaOrientation) &&
                a?.mediaOrientation !== b?.mediaOrientation
              ) {
                if (a?.mediaOrientation === 'landscape') return -1;
                if (b?.mediaOrientation === 'landscape') return 1;
              }

              // push it to the end
              return 1;
            })
            .map((source) => ({
              mediaQuery: source.mediaQuery,
              maxWidth: source.maxWidth,
            }))
            .filter((source) => source.maxWidth !== undefined)
        : [];

      const videoMaxWidths = videoSources
        ? videoSources
            .sort((a, b) => {
              if ((a.minDisplayWidth || b.minDisplayWidth) && a?.minDisplayWidth !== b?.minDisplayWidth) {
                return b?.minDisplayWidth - a?.minDisplayWidth;
              }

              // make sure that landscape is before portrait
              if (
                (a?.mediaOrientation || b?.mediaOrientation) &&
                a?.mediaOrientation !== b?.mediaOrientation
              ) {
                if (a?.mediaOrientation === 'landscape') return -1;
                if (b?.mediaOrientation === 'landscape') return 1;
              }

              // push it to the end
              return 1;
            })
            .map((source) => ({
              mediaQuery: source.mediaQuery,
              maxWidth: source.maxWidth,
            }))
            .filter((source) => source.maxWidth !== undefined)
        : [];

      // Concatenating image and video maxWidths
      return [...imageMaxWidths, ...videoMaxWidths];
    };

    setMaxWidths(getMaxWidths());
  }, [header]);

  return maxWidths;
};
